import { render, staticRenderFns } from "./lawyerYears.vue?vue&type=template&id=0d24e90c&scoped=true&"
import script from "./lawyerYears.vue?vue&type=script&lang=js&"
export * from "./lawyerYears.vue?vue&type=script&lang=js&"
import style0 from "./lawyerYears.vue?vue&type=style&index=0&id=0d24e90c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d24e90c",
  null
  
)

export default component.exports